// extracted by mini-css-extract-plugin
export default {"container":"about_container__GWRmh","text":"about_text__5tpzL","title":"about_title__aAbEH","description":"about_description__jJ8OR","image":"about_image__2+HU3"};